import { Share2 } from "lucide-react";
import { shareItem } from "../../lib/share";

export const ShareButton = ({ title, text, testid }) => (
  <button
    type="button"
    data-testid={testid}
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      shareItem({ title, text });
    }}
    aria-label={`Bagikan ${title}`}
    className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-[#0B63F6] hover:text-[#16C7E8] transition-colors"
  >
    <Share2 className="h-3.5 w-3.5" /> Bagikan paket ini
  </button>
);
